import { useToaster } from 'context/Toaster/ToasterContext';
import useUserBankAccount from 'hooks/queries/banking/useUserBankAccount';
import { useMyWallet, usePostPayout, useWalletPayoutInfo } from 'hooks/queries/marketplace/wallet';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { VARIANT_COLOR_ENUM } from 'types/utils';

const usePayoutModal = () => {
  const { t } = useTranslation();
  const {
    queryResult: { data: wallet },
  } = useMyWallet();
  const { data: bankAccount } = useUserBankAccount();
  const { addToaster } = useToaster();
  const router = useRouter();
  const onSuccess = () => {
    addToaster({
      variant: VARIANT_COLOR_ENUM.SUCCESS,
      message: t('payout-success'),
    });
    router.push('/manage-account/my-wallet/my-balance');
  };
  const { mutate: postPayout } = usePostPayout({ onSuccess });

  const marketplaceBalance = wallet?.marketplaceBalance || 0;

  const { queryResult } = useWalletPayoutInfo();

  return {
    marketplaceBalance,
    currency: wallet?.currency,
    bankAccount,
    postPayout,
    payoutDetail: queryResult.data?.data,
  };
};

export default usePayoutModal;
